import { Alert, Button } from 'antd';

/** A missing required column is a file-level problem — there is no row to blame it on, so this replaces the whole preview/commit panel. */
export function RateLineImportMissingHeaders({ missingHeaders, onReset }: { missingHeaders: string[]; onReset: () => void }) {
  return (
    <>
      <Alert
        className="mb-4"
        type="error"
        showIcon
        title="This sheet is missing required columns"
        description={`Missing header${missingHeaders.length === 1 ? '' : 's'}: ${missingHeaders.join(', ')}`}
      />
      <Button onClick={onReset}>Try another file</Button>
    </>
  );
}
